'use client'

import React from "react";
import { useSelector } from "react-redux";

function HomeFastDeliveryCard() {
  const language = useSelector((state) => state.language.language);
  const text = {
    contactTitleFirst: language === "en" ? "Book Premium Home Beauty Services in" : "प्रीमियम होम ब्यूटी सेवाएं बुक करें",
    contactTitleSecond: language === "en" ? "Noida, Delhi, Gurugram, and Bhopal | DTDB" : "नोएडा, दिल्ली, गुरुग्राम और भोपाल | डीटीडीबी",
    descriptionFirst: language === "en" 
        ? "Looking for top-notch beauty services at home in Noida, Delhi, Gurugram, and Bhopal? We've got you covered! Our expert beauticians bring salon-quality treatments right to your doorstep, offering a wide range of services that cater to all your beauty needs. Whether it's a relaxing facial, a rejuvenating massage, a flawless manicure, or a glamorous makeover, our professionals ensure you receive the best care in the comfort of your own home." 
        : "नोएडा, दिल्ली, गुरुग्राम और भोपाल में घर पर उच्च गुणवत्ता वाली ब्यूटी सेवाएं ढूंढ रहे हैं? हम आपकी पूरी मदद करेंगे! हमारे विशेषज्ञ ब्यूटीशियन सैलून-स्तरीय ट्रीटमेंट सीधे आपके दरवाजे तक लाते हैं, जो आपकी सभी ब्यूटी आवश्यकताओं को पूरा करते हैं। चाहे वह एक आरामदायक फेशियल हो, एक पुनर्जीवित करने वाली मसाज हो, एक बेदाग मैनीक्योर हो, या एक ग्लैमरस मेकओवर हो, हमारे पेशेवर सुनिश्चित करते हैं कि आपको अपने घर के आराम में सर्वोत्तम देखभाल प्राप्त हो।",
    descriptionSecond: language === "en" 
        ? "No more battling traffic or waiting in long queues. Simply book your appointment, and our skilled team will arrive at your location, fully equipped to provide a luxurious experience tailored just for you. We use only the finest products to ensure your skin and hair receive the premium care they deserve." 
        : "अब ट्रैफिक की झंझट या लंबी कतारों में इंतजार करने की जरूरत नहीं है। बस अपनी अपॉइंटमेंट बुक करें, और हमारी कुशल टीम आपके स्थान पर पहुंच जाएगी, पूरी तरह से तैयार, आपको एक शानदार अनुभव प्रदान करने के लिए। हम केवल सर्वोत्तम उत्पादों का उपयोग करते हैं ताकि आपकी त्वचा और बालों को वह प्रीमियम देखभाल मिल सके, जिसके वे हकदार हैं।",
    descriptionThird: language === "en" 
        ? "From the busy streets of Delhi to the vibrant neighborhoods of Noida, the bustling business hubs of Gurugram, and the serene surroundings of Bhopal, our services are available across these major cities. Enjoy the convenience, comfort, and expertise of our beauty services at home. Pamper yourself with the best – because you deserve it!" 
        : "दिल्ली की व्यस्त सड़कों से लेकर नोएडा के जीवंत मोहल्लों तक, गुरुग्राम के व्यस्त व्यापार केंद्रों से लेकर भोपाल की शांतिपूर्ण परिवेश तक, हमारी सेवाएं इन सभी प्रमुख शहरों में उपलब्ध हैं। हमारे घर पर ब्यूटी सेवाओं की सुविधा, आराम और विशेषज्ञता का आनंद लें। खुद को बेहतरीन सेवाओं से लाड़ प्यार दें – क्योंकि आप इसके हकदार हैं!",
  };

  return (
    <>
      <div className="block mx-auto max-w-screen-2xl" style={{ marginTop: "-170px" }}>
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
          <div className="lg:p-2 p-2 rounded-lg">
            <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg">
              <div className="flex justify-between items-center">
                <div className="lg:w-3/5">
                  <h2
                    style={{
                      fontSize: "1.4rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    className="text-lg lg:text-2xl font-bold mb-1"
                  >
                    {text.contactTitleFirst}{" "}
                    <span className="text-pink-600">{text.contactTitleSecond}</span>
                  </h2>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: "1.5",
                      margin: "0 0 10px",
                    }}
                    className="text-justify justify-center"
                  >
                    {text.descriptionFirst}
                  </p>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: "1.5",
                      margin: "0 0 10px",
                    }}
                    className="text-justify justify-center"
                  >
                    {text.descriptionSecond}
                  </p>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: "1.5",
                      margin: "0 0 10px",
                    }}
                    className="text-justify justify-center"
                  >
                    {text.descriptionThird}
                  </p>
                </div>
                <div className="w-1/5 flex-grow hidden lg:lexx md:flex md:justify-items-center lg:justify-end">
                  <span
                    style={{
                      boxSizing: "border-box",
                      display: "inline-block",
                      overflow: "hidden",
                      width: "initial",
                      height: "initial",
                      background: "none",
                      opacity: "1",
                      border: "0px",
                      margin: "0px",
                      padding: "0px",
                      position: "relative",
                      maxWidth: "90%",
                      maxHeight: "110%",
                    }}
                  >
                    <img src="assets/Company/Image3.png" className="rounded-lg" style={{border: "1.5",height:'350px'}} alt="app download" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Custom thin line below the pink box */}
        </div>
      </div>
    </>
  );
}

export default HomeFastDeliveryCard;
